import { ComponentType } from 'react';
import { Route, RouteComponentProps, RouteProps } from 'react-router';
import { Redirect } from 'react-router-dom';
import { AppPathEnum } from '../enums/appPathEnum';
import { SpaMetadatas } from '../utils/spaMetadatas';
import Unauthorized from '../errors/Unauthorized';
import { NOT_AUTHORISED_TO_ACCESS_THIS_AREA } from '../utils/constant';
import { useCurrentUser } from '../auth/useCurrentUser';
import { getRouteAccess } from '../auth/routeAccess';

interface Props extends RouteProps {
    component: ComponentType<RouteComponentProps<any>> | ComponentType<any>;
    path: AppPathEnum;
}

export default function PrivateRoute({ component: Component, path, ...rest }: Props) {
    const user = useCurrentUser();
    const access = getRouteAccess(path, user, SpaMetadatas.find(item => item.name === path)?.allowedRoles);
    return <Route {...rest} path={path} render={props => {
        if (access.redirect) return <Redirect to={{ pathname: access.redirect, search: props.location.search }} />;
        if (!access.allowed) return <Unauthorized message={NOT_AUTHORISED_TO_ACCESS_THIS_AREA} />;
        return <Component {...props} />;
    }} />;
}
